<template>
    <v-alert v-if="showAlert"
      class="feedback-alert"
      :class="borderColorObject"
      border="start"
      close-label="Close Alert"
      color="white"
      text-color="black"
      :border-color="getEmphasisColor"
      density="compact"
      closable
      @click:close="$emit('close-alert')"
    >
      {{ text }}
    </v-alert>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FeedbackAlert',
  props: {
    text: {
      type: String,
      required: true,
      default: 'N/A'
    },
    feedbackType: {
      type: String,
      required: false,
      default: 'info',
      validator (value : string) {
        return ['success', 'warning', 'error', 'info'].includes(value)
      }
    }
  },
  beforeUnmount () {
    if (this.closeAlertTimeout !== undefined) {
      this.$emit('close-alert')
      clearTimeout(this.closeAlertTimeout)
    }
  },
  data () {
    return {
      closeAlertTimeout: 0 as number | undefined,
      showAlert: true
    }
  },
  computed: {
    getEmphasisColor (this: { feedbackType: string }) {
      switch (this.feedbackType) {
        case 'success':
          return 'success'
        case 'warning':
          return 'warning'
        case 'error':
          return 'error'
        default:
          return 'black'
      }
    },
    borderColorObject (this: { feedbackType: string }) {
      return {
        'border-success': this.feedbackType === 'success',
        'border-warning': this.feedbackType === 'warning',
        'border-error': this.feedbackType === 'error',
        'border-info': this.feedbackType === 'info'
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/colors.scss";

.feedback-alert {
  width: auto;
  // max-width: 30em;
}

/* .border-success {
  border: 1px solid #bae0bc;
}

.border-warning {
  border: 1px solid #fdd29d;
}

.border-error {
  border: 1px solid #e09da9;
}

.border-info {
  border: 1px solid #9d9d9d;
} */
</style>
